/// <amd-module name="Analytics/Common/Utilities/ODataClientUtilities" />
import { AnalyticsODataVersion, ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import * as Resources from "Analytics/Common/Resources";
import { replaceRouteValues, Uri } from "VSS/Platform/Util/Url";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";

export function formatRequestUrl(rootPath: string, routeTemplate: string, routeValues: any, queryParams?: { [key: string]: any }): string {
    let url = rootPath + replaceRouteValues(routeTemplate, routeValues || {});
    if (queryParams) {
        const uri = new Uri(url);
        uri.addQueryParams(queryParams);
        url = uri.absoluteUri;
    }
    return url;
}

export function formatODataCommand(command: string): string {
    return `vsts-widget-${command}`;
}

export function checkODataPageValue(requestResult: any): void {
    if (requestResult == null) {
        throw new Error(Resources.ODataPayloadBodyNotFoundErrorText);
    }
    if (requestResult.value == null) {
        throw new Error(Resources.ODataResponseValueElementNotFoundErrorText);
    }
}

export function generateCustomODataHeaders(queryOptions: ODataQueryOptions, batchIdentifier?: string): HeadersInit {
    const headers: HeadersInit = {
        Accept: `*/*;api-version=${latestODataVersion}`,
        Prefer: "omit-values=nulls"
    };

    // Note: You can't use both singlePage and max page size. Single Page wins if both are present.
    if (queryOptions.expectSinglePage) {
        headers["X-TFS-Prefer"] = "VSTS.Analytics.ExpectSinglePage=true";
    } else if (queryOptions.maxPageSize) {
        headers["Prefer"] += `,odata.maxpagesize=${queryOptions.maxPageSize}`;
    }

    if (batchIdentifier) {
        headers["Content-Type"] = `multipart/mixed; boundary=batch_${batchIdentifier}`;
        headers["Accept"] = `text/plain;api-version=${latestODataVersion}`;
    }

    if (queryOptions.getProviderSyncDates) {
        headers["GetSyncDates"] = "true";
    }

    if (queryOptions.syncDateConditions) {
        headers["X-TFS-If-SyncDates-Newer"] = JSON.stringify(queryOptions.syncDateConditions);
    }

    return headers;
}
